import { render, staticRenderFns } from "./ProductSideSheetHero.vue?vue&type=template&id=2eccc080&scoped=true"
import script from "./ProductSideSheetHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheetHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheetHero.vue?vue&type=style&index=0&id=2eccc080&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eccc080",
  null
  
)

export default component.exports